import OperationsReport from './OperationsReport';
export default function FinanceReports(){return <OperationsReport kind="finance"/>;}
